import React, { useEffect, useState } from "react";
import PageHeaders from "./header";
import ResumeCard from "./resumecard";
import Badge from "./badge";
import { AiOutlineCalendar } from "react-icons/ai";
import { apiGet } from "../../../api/api_methods";
import { useStores } from "../../../store";
import LabelPopup from "../../recruiter/Resume/LabelPopup";
import { MdAddCircleOutline } from "react-icons/md";
import { useObserver } from "mobx-react";
import { toJS } from "mobx";
import Loader from "../loader";
import ResponsiveHeader from "./responsiveHeader";
import RecuiterStore from "../../../store/recuiter_store";

const Tags = () => {
  const [tab, setTab] = useState([]); // Changed to array
  const [searchQuery, setSearchQuery] = useState("");
  // const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedTabs1, setSelectedTabs1] = useState([2]);
  const [fetchedFirstTime, setFetchedFirstTime] = useState(false);
  const { PopupStore, LabelStore, RecuiterStore } = useStores();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  useEffect(() => {
    LabelStore.fetchLabelsData();
    console.log("Fetching labels data");
  }, []);

  const getScore = (item) => {
    if (!item || !Array.isArray(item.overallScore)) return 0;

    const toTime = (val) => {
      if (typeof val === "number") return val;
      const t = new Date(val).getTime();
      return Number.isFinite(t) ? t : 0;
    };

    const totalScores = (item.overallScore || []).filter(
      (scoreObj) => scoreObj && scoreObj.name === "total",
    );

    if (totalScores.length === 0) return 0;

    const latestTotalScore = totalScores.sort(
      (a, b) => toTime(b.generatedAt) - toTime(a.generatedAt),
    )[0];

    return typeof latestTotalScore?.score === "number"
      ? latestTotalScore.score
      : 0;
  };

  useEffect(() => {
    const activeTab = selectedTabs1[0];
    const labels = LabelStore.labelFetched || [];
    const lowerCaseQuery = searchQuery?.toLowerCase();

    const filtered = labels.map((label) => {
      // Initialize data array based on selected tab
      let data = [];

      // Add data based on selected tab
      if (activeTab === "All Applicants" || activeTab === 0) {
        data = [
          ...(label.applications || []),
          ...(label.mockTest || []),
          ...(label.interview || []),
          ...(label.jobPost || []),
        ];
      } else if (activeTab === "MCQ's Applicants") {
        data = [...(label.mockTest || [])];
      } else if (activeTab === "Technical Interview Applicants") {
        data = (label.interview || []).filter(
          (i) =>
            i.interviewType?.toLowerCase().includes("technical") ||
            i.technology?.toLowerCase().includes("technical"),
        );
      } else if (activeTab === "HR Interview Applicants") {
        data = (label.interview || []).filter(
          (i) =>
            i.interviewType?.toLowerCase().includes("hr") ||
            i.technology?.toLowerCase().includes("hr"),
        );
      } else if (activeTab === "Job Applicants") {
        data = [...(label.jobPost || [])];
      } else {
        // Fallback or multiple selection if needed
        data = [
          ...(label.applications || []),
          ...(label.mockTest || []),
          ...(label.interview || []),
          ...(label.jobPost || []),
        ];
      }

      // Apply search filter if search query exists
      if (searchQuery) {
        data = data.filter((item) => {
          // Common search fields for all types
          const searchableFields = [
            item.userId?.name,
            item.userId?.mail,
            item.name,
            item.email,
            item.jobTitle,
            item.technology,
          ].filter(Boolean); // Remove null/undefined values

          return searchableFields.some((field) =>
            field.toLowerCase().includes(lowerCaseQuery),
          );
        });
      }

      return { ...label, data };
    });

    console.log("Filtered Data:", filtered);
    setFilteredData(filtered);
    console.log(selectedTabs1, "Selected Tabs");
  }, [selectedTabs1, LabelStore.labelFetched, searchQuery]);

  const handleCreateLabel = () => {
    PopupStore.setLabelPopup(true);
  };

  // Tab click handler
  const handleTabClick = (id) => {
    setTab((prevTabs) => {
      // If the tab is already selected, remove it; otherwise, add it
      if (prevTabs.includes(id)) {
        return prevTabs.filter((tabId) => tabId !== id); // Remove tab ID if already selected
      }
      return [...prevTabs, id]; // Add tab ID if not already selected
    });
  };

  const handleScroll = () => {
    setIsDropdownOpen(false);
  };

  return useObserver(() => (
    <>
      <Loader loader={LabelStore.loader} />
      <LabelPopup handleDelete={() => LabelStore.fetchLabelsData()} />
      <div className="w-full md:w-full mx-auto mt-5">
        <div className="w-[93%] md:w-[97%] mx-auto">
          <ResponsiveHeader
            showNotification={false}
            showButton={false}
            showDropdown={false}
            selectorAction={(e) => setSelectedTabs1([e.target.value])}
            selectorOptions={[
              { name: "All Applicants", id: "All Applicants" },
              { name: "MCQ's Applicants", id: "MCQ's Applicants" },
              {
                name: "Technical Interview Applicants",
                id: "Technical Interview Applicants",
              },
              {
                name: "HR Interview Applicants",
                id: "HR Interview Applicants",
              },
              { name: "Job Applicants", id: "Job Applicants" },
            ]}
            showrefresh={true}
            refreshAction={() => {
              LabelStore.fetchLabelsData();
            }}
            title="Tags"
            buttonLable={"Create Label"}
            handleInputChange={(e) => {
              // console.log(e.target.value);
              setSearchQuery(e.target.value);
            }}
            // onClickButton={(selectedOptions) => {
            //   setSelectedTabs1(selectedOptions.map((option) => option.id));
            // }}
            isDropdownOpen={isDropdownOpen}
            setIsDropdownOpen={setIsDropdownOpen}
          />
        </div>

        {!LabelStore.loader && (
          <div
            className="overflow-x-scroll no-scrollbar pb-5 pr-5 md:pr-0 md:mr-5 mr-5"
            onScroll={handleScroll}
          >
            <div className="flex whitespace-nowrap ">
              {filteredData?.map((label, index) => (
                <div
                  className="flex flex-col md:w-fit lg:w-fit w-fit items-center h-fit"
                  key={index}
                >
                  {/* Badge: Static element */}
                  <div className=" px-5 lg:w-full md:w-full w-[100%] lg:block md:block ml-2">
                    <Badge
                      id={label._id}
                      title={label.name}
                      count={label.data.length}
                      color={label.color}
                      width={"w-full"}
                      description={label.description}
                    />
                  </div>
                  {/* Scrollable container for ResumeCard - Mobile View Adjustments */}
                  <div className=" h-[65vh] md:h-[80vh] md:px-7 lg:px-7 px-4 md:pr-3 lg:pr-3 overflow-y-auto md:overflow-y-hidden hover:overflow-y-auto custom-scrollbar chat-scroll-bar overflow-x-clip pb-10 lg:w-full md:w-full ">
                    {label.data.map((item, i) => (
                      <ResumeCard
                        key={i}
                        type={(() => {
                          if (label.applications?.includes(item))
                            return "applications";
                          if (label.resumeSorting?.includes(item))
                            return "resumeSorting";
                          if (label.jobPost?.includes(item)) return "jobPost";
                          if (label.interview?.includes(item))
                            return "interview";
                          if (label.mockTest?.includes(item)) return "mockTest";
                          return "unknown";
                        })()}
                        name={
                          item.name ||
                          item.title ||
                          item.jobTitle ||
                          item?.userId?.name
                        }
                        date={label.createdAt}
                        mail={
                          item.email ||
                          item?.userId?.email ||
                          item?.userId?.mail ||
                          " - "
                        }
                        pic={(() => {
                          if (label.applications?.includes(item))
                            return item?.userId?.pic;
                          if (label.resumeSorting?.includes(item)) return null;
                          if (label.jobPost?.includes(item))
                            return item?.recruiterId?.pic;
                          if (label.interview?.includes(item))
                            return "interview";
                          if (label.mockTest?.includes(item)) return "mockTest";
                          return "unknown";
                        })()}
                        resume={item.resume || item.link}
                        percentage={item.match?.[0]?.score || getScore(item)}
                        jobPostId={item.jobPostId?._id || null}
                        ApplicantId={item.userId || null}
                        id={item._id}
                        location={item.jobLocation}
                        onClick={() => {
                          console.log("Clicked on", item);
                        }}
                        jobTitle={item.jobPostId?.jobTitle ?? ""}
                      />
                    ))}
                  </div>
                </div>
              ))}

              {/* "Create New" button */}
              <div
                className={`h-fit flex border-black min-w-64 gap-20 items-center bg-opacity-75 py-2 px-5 ml-6 rounded-lg mt-2 cursor-pointer text-white bg-slate-900 ${
                  filteredData.length === 0 ? "ml-4" : ""
                }`}
                onClick={handleCreateLabel}
              >
                <span>Create New</span>
                <div className="bg-slate-950 px-3 py-1 rounded-md">
                  <MdAddCircleOutline />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  ));
};

export default Tags;
